export default {
  TokenInvalid: false, // token是否有效
}